import {useState} from 'react';
import {ColorPicker as Picker, useColor} from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
import OutsideClickHandler from "react-outside-click-handler";
import Button from "../Button/Button";

type ColorPickerProps = {
    className?: string,
    changeHandler: any,
    currentColor: any,
}

const ColorPicker = (props: ColorPickerProps) => {
    const {className, changeHandler, currentColor} = props;
    const [color, setColor] = useColor( 'hex', currentColor);
    const [showPicker, setShowPicker] = useState(false);
    const handlePicker = () => setShowPicker((prev) => !prev);


    const selectColorHandler = () => {
        changeHandler(color.hex);
    }


    return (
        <div className='color-picker-wrapper'>
            {showPicker && (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        setShowPicker(false);
                    }}
                >
                    <div className={`color__picker ${className}`}>
                        <Picker
                            width={250}
                            height={100}
                            color={color}
                            onChange={setColor}
                            hideHSV
                            dark
                            alpha
                        />
                        <Button
                            variant='btn-primary'
                            size='btn-md'
                            onClick={selectColorHandler}
                            style={{width: "100%"}}
                        >
                            Select
                        </Button>

                    </div>
                </OutsideClickHandler>
            )}
            <div
                className='color__block'
                style={{
                    backgroundColor: currentColor,
                    border: "1px solid var(--border)"
                }}
                onClick={handlePicker}
            ></div>
        </div>
    );
}

export default ColorPicker;